<template>
  <div>
    <v-menu
      v-model="showMenu"
      max-height="300"
      min-width="300"
      nudge-bottom="5"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <div class="tt-input">
          <v-text-field
            color="metalBlue"
            label="タンクタイプ"
            :placeholder="showMenu?' ':''"
            append-icon="mdi-menu-down"
            :readonly="!showMenu"
            :rules="[rules.required]"
            :value="tankTypeName"
            v-on="on"
            @click="focusHandler"
            @click:append="focusHandler"
          />
        </div>
      </template>

      <v-list>
        <v-list-tile class="search-tank-field">
          <v-text-field
            ref="searchField"
            v-model="searchTank"
            outline
            single-line
            autofocus
            label="タンク情報で検索する"
            color="metalBlue"
            prepend-inner-icon="mdi-magnify"
            class="mt-4"
          />
        </v-list-tile>
        <v-list-tile v-if="!tankTypeFilter.length">
          <v-list-tile-content>
            該当するタンクタイプがありません。
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-for="(item, index) in tankTypeFilter"
          :key="index"
          v-ripple
          style="cursor:pointer"
          @click="menuCloseHandler(item.id)"
        >
          <v-list-tile-title
            :style="item.id === value ?
              'color:#3f6fb6' : ''"
          >
            {{ item.tankName }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TankTypeSelect',
  props: {
    value: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      tankType: '',
      searchTank: '',
      showMenu: false,
      rules: {
        required: value => !!value || '必須項目です。'
      }
    }
  },
  computed: {
    ...mapState('tankTypes', ['tankTypes']),
    tankTypeName () {
      const tankType = this.tankTypes.find(t => t.id === this.value)
      return tankType ? tankType.tankName : null
    },
    tankTypeFilter () {
      return this.tankTypes.filter(t => {
        let result = true
        const queryTexts = this.searchTank.replace(/[Ａ-Ｚａ-ｚ０-９]/g,
          function (s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
          })
          .toLowerCase()
          .replaceAll('　', ' ')
          .split(' ')

        for (let e of queryTexts) {
          result = (
            t.makerName.toLowerCase().includes(e) ||
            String(t.oilMaxVolume).includes(e) ||
            String(t.tankMaxVolume).includes(e) ||
            t.tankName.toLowerCase().includes(e) ||
            t.tankTypeCode.toLowerCase().includes(e)
          )

          if (!result) return result
        }
        return result
      })
    }
  },
  methods: {
    focusHandler () {
      this.searchTank = ''
      this.showMenu = true
      setTimeout(() => {
        this.$refs.searchField.focus()
      }, 100)
    },
    menuCloseHandler (id) {
      this.$emit('input', id)
      this.showMenu = false
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.search-tank-field{
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
  padding: 10px 0 15px;
  .v-text-field__details{
    display: none;
  }
  .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea{
    width: 0;
    margin-top: 0;
    cursor: text;
  }
  .v-text-field--box>.v-input__control>.v-input__slot, .v-text-field--full-width>.v-input__control>.v-input__slot, .v-text-field--outline>.v-input__control>.v-input__slot{
    min-height: 0px;
    max-height: 35px;
  }
  .v-text-field__slot .v-label{
    top: 6px;
    font-size: 0.8rem;
  }
  .v-text-field.v-text-field--enclosed .v-input__append-inner, .v-text-field.v-text-field--enclosed .v-input__append-outer, .v-text-field.v-text-field--enclosed .v-input__prepend-inner, .v-text-field.v-text-field--enclosed .v-input__prepend-outer{
    margin-top: 5px;
  }
}
/deep/.v-list__tile__content{
  opacity: 0.8;
  width: min-content;
}
/deep/.v-list{
  padding: 0px;
}
/deep/.tt-input{
  .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea{
    cursor: pointer;
  }
}
</style>
